module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "top-bar"
    }
  }, [_c('h1', {
    staticClass: "text-white"
  }, [_vm._v("\n      MISIÓN\n\t\t")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-900b1c90"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopBar.vue
// module id = 449
// module chunks = 1